import React, { Component } from 'react';
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux';
import AdminHeader from '../../Admin/admin-header/index';
import Aside from '../correspondent-aside/index';
import Main from '../correspondent-main/index';
import Sidebar from '../correspondent-sidebar/index';
import { getPageTitle } from '../correspondent-main/constants';
import Preloader from '../../components/UI/Preloader';
import { ToastContainer, toast } from 'react-toastify';
import withAuth from '../../components/Services/WithAuth';
import 'react-toastify/dist/ReactToastify.min.css';
// import Overlay from "../overlay";
/* import SearchFilter from "../search-result";
import * as action from './action' */
// import Admin from "../admin";

class Correspondent extends Component {
    constructor(props, state) {
        super(props, state);
        this.state = {
            showAlerts: false,
            showMenu: false
        }
    }
    showHideSideBar = () => {
        this.setState({ showAlerts: !this.state.showAlerts });
    }

    showHideMenu = () => {
        this.setState({ showMenu: !this.state.showMenu });
    }

    render() {
        const { showAlerts, showMenu } = this.state;
        var cls = "app ";
        if (showAlerts) {
            cls += "sidebar-open ";
        }
        if (showMenu) {
            cls += "aside-open";
        }
        let pageTitle = getPageTitle(this.props.location.pathname)
        return (
            <section className={cls}>
                <Helmet>
                    <title>{pageTitle} | Rubix</title>
                </Helmet>

                <AdminHeader {...this.props} />
                <section className="app-body">
                    {/* <Overlay isOpen={this.state.isOpen} >{this.state.searchResult}</Overlay> */}
                    <Aside {...this.props} showHideMenu={this.showHideMenu} />
                    <Main {...this.props} />
                    <Sidebar />
                </section>

                <Preloader></Preloader>
                <ToastContainer hideProgressBar={true} position="top-center"></ToastContainer>
            </section>
        );
    }
}
const mapStateToProps = (state, ownProps) => ({

})

const mapDispatchToProps = (dispatch) => ({

    // searchParameter: (searchText) => { dispatch(action.searchParameter(searchText)) }

});
export default withAuth(connect(mapStateToProps, mapDispatchToProps)(Correspondent));
